import React, { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import './Navbar.css';

const Navbar = ({ onNavigate, light }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = (target) => {
    if (onNavigate) { onNavigate(target); }
  };

  return (
    <nav className={`navbar${light ? ' navbar--light' : ''}`}>
      <div className="navbar-logo">
        <img
          src="/Sndp/logo.png"
          alt="Pravasi SNDP Yogam Logo"
        />
      </div>

      <button className="navbar-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </button>

      <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
        <div className="nav-menu">
          <a href="#home" className="nav-link active" onClick={(e) => { e.preventDefault(); navigate('home'); }}>Home</a>
          <div className="nav-about-wrapper">
            <span className="nav-link nav-dropdown">
              About <FiChevronDown size={14} />
            </span>
            <div className="nav-about-dropdown">
              <button onClick={() => navigate('ourhistory')}>Our History</button>
              <button onClick={() => navigate('leadership')}>Leadership</button>
            </div>
          </div>
          <a href="#gallery" className="nav-link" onClick={(e) => { e.preventDefault(); navigate('gallery'); }}>Gallery</a>
          <a href="#news" className="nav-link" onClick={(e) => { e.preventDefault(); navigate('news'); }}>News &amp; Articles</a>
          <a href="#eventcalender" className="nav-link" onClick={(e) => { e.preventDefault(); navigate('eventcalendar'); }}>Event Calendar</a>
          <a href="#constitution" className="nav-link" onClick={(e) => { e.preventDefault(); navigate('constitution'); }}>Constitution</a>
          <a href="#membership" className="nav-link" onClick={(e) => { e.preventDefault(); navigate('membership'); }}>Membership</a>
          <a href="#contact" className="nav-link" onClick={(e) => { e.preventDefault(); navigate('contact'); }}>Contact Us</a>
        </div>
        <a href="#donate" className="donate-btn" onClick={(e) => { e.preventDefault(); navigate('donation'); }}>Donation</a>
      </div>
    </nav>
  );
};

export default Navbar;
